import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Main from "./main";
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import Iconify from "../../components/iconify";
import { TeacherFloatingToolbar } from "@/components/TeacherFloatingToolbar";
import { BannerDisplay } from "@/components/BannerDisplay";
// ----------------------------------------------------------------------

export default function MSLayout({ children, backLabel, backTo }) {
  const navigate = useNavigate();
  const onBack = () => {
    if (backTo) {
      navigate(backTo);
    } else {
      navigate(-1);
    }
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          gap: 0,
          mt: 0,
          pt: 0,
        }}
      >
        {backLabel && (
          <Button
            onClick={onBack}
            sx={{
              position: "absolute",
              top: 20,
              left: 16,
              backgroundColor: "rgba(255, 255, 255, 0.32)",
              backdropFilter: "blur(8px)",
              border: "none",
              borderRadius: "8px",
              padding: "8px",
              minWidth: "auto",
              height: "auto",
              color: "#1c252e",
              fontSize: "14px",
              fontFamily: "'Proxima Nova', sans-serif",
              fontWeight: 700,
              lineHeight: "22px",
              zIndex: 1000,
              textTransform: "none",
              display: "flex",
              alignItems: "center",
              gap: "4px",
              "&:hover": {
                backgroundColor: "rgba(255, 255, 255, 0.45)",
              },
            }}
            variant="contained"
            disableElevation
          >
            <Iconify icon="eva:arrow-ios-back-fill" width={18} height={18} />
            {backLabel}
          </Button>
        )}
        <Main
          sx={{
            mt: 0,
            px: 0,
            py: 0,
          }}
        >
          <BannerDisplay />
          {children}
        </Main>
      </Box>
      <TeacherFloatingToolbar />
    </>
  );
}

MSLayout.propTypes = {
  children: PropTypes.node,
};
